import { User } from '@/types/users';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Product } from './ProductApi';
import { UUID } from '@/types/types';
import { fileTypeToHeader } from '@/utils/utilities';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum OrderStatus {
	NOT_SENT = 'NOT_SENT',
	SENT = 'SENT',
	CONFIRMED = 'CONFIRMED',
	COMPLETED = 'COMPLETED',
}

export enum TransportType {
	EWAN = 'ewan',
	COURIER = 'courier',
	SELF_PICKUP = 'self-pickup',
}

export interface OrderShippingData {
	shippingName: string;
	shippingStreet: string;
	shippingCity: string;
	shippingPostalCode: string;
	shippingPhoneNumber: string;
	shippingDate: Date;
	shippingTransportType: TransportType;
}

export interface Order extends BaseEntity, OrderShippingData {
	number: number;
	name: string;
	user: User;
	description: string;
	status: OrderStatus;
	products: Product[];
	totalPrice: number;
	totalDiscountedPrice: number;
}

class OrderApi extends EntityApi<Order> {
	constructor() {
		super(ApiQueryKey.orders);
		this.changeStatus = this.changeStatus.bind(this);
		this.generatePdf = this.generatePdf.bind(this);
		this.generateCuttingPdf = this.generateCuttingPdf.bind(this);
		this.generateLabelsPdf = this.generateLabelsPdf.bind(this);
	}

	async changeStatus({
		orderId,
		status,
	}: {
		orderId: UUID;
		status: OrderStatus;
	}) {
		const response = await httpClient.patch<Order>(
			`${this.queryKey}/${orderId}/change-status`,
			{
				status,
			}
		);
		return response.data;
	}

	async generatePdf({ order }: { order: Order }) {
		const response = await httpClient.get<Blob>(
			`${this.queryKey}/${order.id}/export`,
			{
				headers: {
					Accept: fileTypeToHeader('pdf'),
				},
				responseType: 'blob',
			}
		);

		return response.data;
	}

	async generateCuttingPdf({ order }: { order: Order }) {
		const response = await httpClient.get<Blob>(
			`${this.queryKey}/${order.id}/export-cutting`,
			{
				headers: {
					Accept: fileTypeToHeader('pdf'),
				},
				responseType: 'blob',
			}
		);

		return response.data;
	}

	async generateLabelsPdf({ order }: { order: Order }) {
		const response = await httpClient.get<Blob>(
			`${this.queryKey}/${order.id}/export-labels`,
			{
				headers: {
					Accept: fileTypeToHeader('pdf'),
				},
				responseType: 'blob',
			}
		);

		return response.data;
	}
}

export default new OrderApi();
